import { gql } from '@apollo/client';

export const orderHistoryGql = gql`
  query OrderHistory(
    $initialRow: Int!
    $nextRows: Int!
    $purchaseOrderId: ID!
    $productId: ID!
    $deliveryDate: String
    $branchId: ID!
  ) {
    OrderHistory(
      purchaseOrderId: $purchaseOrderId
      productId: $productId
      deliveryDate: $deliveryDate
      branchId: $branchId
      initialRow: $initialRow
      nextRows: $nextRows
    ) {
      auditRegisterDate #registro de alteração
      newScheduleDate # nova agenda
      scheduleDate # agenda anterior
      updateOrigin # alterado por
      delayDescriptionReason # motivo
      itemQuantity # quantidade
      sciaStatusDescription # agendamento original
      statusDate # data recusa/aceite
      suggestedScheduleDate # agenda sugerida
      daysPaymentTerm # penalização prazo pgto
      monetaryDiscountNoShow # desconto No Show
      monetaryDiscountScheduleChange #desc alt tardia
      totalRows
    }
  }
`;
